<template>
  <modal
    ref="addCustomer"
    :ok-disabled="loading || saving"
    :ok-title="!edit ? 'Pridať' : 'Upraviť'"
    :title="!edit ? 'Nový zákazník' : 'Upraviť zákazníka'"
    cancel-title="Zrušiť"
    full-height
    name="add-customer"
    scrollable
    size="lg"
    type="from-right"
    @hidden="Object.assign($data, $options.data())"
    @ok="saveCustomer"
    @show="fetchData"
  >
    <b-overlay :blur="null" :show="loading" class="h-100" opacity="0">
      <transition mode="out-in" name="fadeShort">
        <div v-if="!loading" ref="scroll" v-bar>
          <div>
            <b-row>
              <b-col md="6">
                <h4 class="mb-3">Základné údaje</h4>
                <b-form-group label="Názov spoločnosti" label-for="name">
                  <b-form-input
                    v-model="form.name"
                    v-validate="'required'"
                    :class="{ 'is-invalid': errors.has('name') }"
                    data-vv-as="Názov spoločnosti"
                    name="name"
                  />

                  <b-form-invalid-feedback>
                    {{ errors.first('name') }}
                  </b-form-invalid-feedback>
                </b-form-group>
                <b-form-group label="Skupina" label-for="group">
                  <b-input-group>
                    <b-form-select
                      v-model="form.group_id"
                      :select-size="1"
                      name="group"
                    >
                      <option :value="null">--Nedefinované--</option>
                      <option
                        v-for="group in selection.groups"
                        :key="group.id"
                        :value="group.id"
                      >
                        {{ group.name }}
                      </option>
                    </b-form-select>
                    <b-input-group-prepend>
                      <b-btn v-b-toggle.groups variant="secondary">
                        <b-icon icon="pencil-square" />
                      </b-btn>
                    </b-input-group-prepend>
                  </b-input-group>
                  <b-collapse
                    id="groups"
                    @hidden="$vuebar.refreshScrollbar($refs.scroll, {})"
                    @shown="$vuebar.refreshScrollbar($refs.scroll, {})"
                  >
                    <b-card class="mb-3" title="Upraviť skupiny">
                      <div ref="scroll" v-bar style="max-height: 250px">
                        <div>
                          <div
                            v-for="(group, index) in selection.groups"
                            :key="index"
                            class="form-group mb-1"
                          >
                            <b-input-group size="sm">
                              <b-input-group-prepend>
                                <b-btn
                                  variant="outline-danger"
                                  @click="
                                    removeGroup(selection.groups[index].id)
                                  "
                                >
                                  <b-icon icon="dash" />
                                </b-btn>
                              </b-input-group-prepend>
                              <b-form-input
                                v-model="selection.groups[index].name"
                                size="sm"
                                @blur.native="
                                  addGroup(
                                    selection.groups[index].id,
                                    selection.groups[index].name,
                                  )
                                "
                              />
                            </b-input-group>
                          </div>
                        </div>
                      </div>
                      <b-btn
                        class="mb-2 mx-auto"
                        size="sm"
                        variant="outline-primary"
                        @click.prevent="add"
                      >
                        <icon class="icon-fw" name="plus" />
                      </b-btn>
                    </b-card>
                  </b-collapse>
                </b-form-group>
                <b-form-group label="Oprávnená osoba" label-for="owner">
                  <b-form-input v-model="form.owner" name="owner" />
                </b-form-group>
                <b-form-group label="Kontaktný telefón" label-for="phone">
                  <b-form-input v-model="form.phone" name="phone" />
                </b-form-group>
                <b-form-group label="Email" label-for="email">
                  <b-form-input
                    v-model="form.email"
                    v-validate="'email'"
                    :class="{ 'is-invalid': errors.has('email') }"
                    data-vv-as="Email"
                    name="email"
                  />

                  <b-form-invalid-feedback>
                    {{ errors.first('email') }}
                  </b-form-invalid-feedback>
                </b-form-group>
                <b-form-group label="Stav" label-for="state">
                  <b-form-select
                    v-model="form.active"
                    :select-size="1"
                    name="state"
                  >
                    <option :value="1">Aktívny</option>
                    <option :value="0">Neaktívny</option>
                  </b-form-select>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <h4 class="mb-3">Údaje o spoločnosti</h4>
                <b-form-group label="Zapísaná v" label-for="registration">
                  <b-form-input
                    v-model="form.registration"
                    name="registration"
                  />
                </b-form-group>
                <b-form-group label="Druh právneho subj." label-for="formID">
                  <b-form-select
                    v-model="form.formID"
                    :select-size="1"
                    name="formID"
                  >
                    <option :value="null">--Nedefinované--</option>
                    <option
                      v-for="item in attributes.form"
                      :key="item.id"
                      :value="item.id"
                    >
                      {{ item.name }}
                    </option>
                  </b-form-select>
                </b-form-group>
                <b-form-group label="Vl.č." label-for="registrationCode">
                  <b-form-input
                    v-model="form.registrationCode"
                    name="registrationCode"
                  />
                </b-form-group>
                <b-form-group label="IČO" label-for="regNumber">
                  <b-form-input v-model="form.regNumber" name="regNumber" />
                </b-form-group>
                <b-form-group label="DIČ" label-for="taxNumber">
                  <b-form-input v-model="form.taxNumber" name="taxNumber" />
                </b-form-group>
                <b-form-group label="IČ DPH" label-for="taxRegNumber">
                  <b-form-input
                    v-model="form.taxRegNumber"
                    name="taxRegNumber"
                  />
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="6">
                <h4 class="mb-3">Sídlo</h4>
                <b-form-group label="Ulica" label-for="street">
                  <b-form-input
                    v-model="form.street"
                    v-validate="'required'"
                    :class="{ 'is-invalid': errors.has('street') }"
                    data-vv-as="Ulica"
                    name="street"
                  />

                  <b-form-invalid-feedback>
                    {{ errors.first('street') }}
                  </b-form-invalid-feedback>
                </b-form-group>
                <b-form-group label="Číslo" label-for="streetNumber">
                  <b-form-input
                    v-model="form.streetNumber"
                    v-validate="'required|numeric'"
                    :class="{ 'is-invalid': errors.has('streetNumber') }"
                    data-vv-as="Číslo"
                    name="streetNumber"
                  />

                  <b-form-invalid-feedback>
                    {{ errors.first('streetNumber') }}
                  </b-form-invalid-feedback>
                </b-form-group>
                <b-form-group label="Súp. číslo" label-for="streetRegNumber">
                  <b-form-input
                    v-model="form.streetRegNumber"
                    name="streetRegNumber"
                  />
                </b-form-group>
                <b-form-group label="Mesto" label-for="city">
                  <b-form-input
                    v-model="form.city"
                    v-validate="'required'"
                    :class="{ 'is-invalid': errors.has('city') }"
                    data-vv-as="Mesto"
                    name="city"
                  />

                  <b-form-invalid-feedback>
                    {{ errors.first('city') }}
                  </b-form-invalid-feedback>
                </b-form-group>
                <b-form-group label="PSČ" label-for="postCode">
                  <b-form-input v-model="form.postCode" name="postCode" />
                </b-form-group>
              </b-col>
            </b-row>
          </div>
        </div>
      </transition>
    </b-overlay>
  </modal>
</template>
<script>
import Modal from '@/components/Modal'

export default {
  components: {
    Modal,
  },
  data() {
    return {
      loading: false,
      edit: false,
      saving: false,
      attributes: [],
      selection: {
        groups: [],
      },
      form: {},
    }
  },
  methods: {
    add() {
      this.selection.groups.push({ id: null, name: null })
    },
    fetchData() {
      this.loading = true
      this.axios
        .all([
          this.$api.get('customers/get_groups'),
          this.$api.get('attributes/get', {
            params: {
              select: 'customers',
            },
          }),
          this.edit
            ? this.$api.get(`customers/${this.$route.params.id}/get`)
            : null,
        ])
        .then(
          this.axios.spread((groups, attr, formdata) => {
            this.selection.groups = groups.data.data
            this.attributes = attr.data
            this.form = formdata ? formdata.data.data : {}
            this.loading = false
          }),
        )
    },
    saveCustomer(e) {
      e.preventDefault()
      this.$validator.validateAll().then(() => {
        if (!this.errors.any() && !this.loading) {
          this.saving = true
          this.$api
            .post(this.edit ? 'customers/edit' : 'customers/add', this.form)
            .then((res) => {
              this.$swal({
                type: 'success',
                position: 'top',
                showCloseButton: true,
                text: res.data.message,
                timer: 5000,
              })
              this.saving = true
              this.$root.$emit('modal-hide', 'add-customer')
              this.$root.$emit('reloadCustomerData')
              if (!this.edit) {
                this.$router.push({
                  name: 'customerView',
                  params: { id: res.data.meta.id },
                })
              }
            })
        } else {
          this.$swal({
            type: 'warning',
            position: 'top',
            showCloseButton: true,
            text: 'Formulár nieje správne vyplnený',
            timer: 5000,
          })
        }
      })
    },
    getGroupIndex(id) {
      let item = this.selection.groups.find((item) => item.id == id)
      return this.selection.groups.indexOf(item)
    },
    addGroup(id, val) {
      this.$api
        .post('customers/add_group', {
          id: id,
          name: val,
        })
        .then((response) => {
          let item = this.getGroupIndex(id)
          this.selection.groups[item].id = response.data.id
        })
    },
    removeGroup(id) {
      this.$api.post('customers/remove_group/' + id).then(() => {
        let item = this.getGroupIndex(id)
        this.$delete(this.selection.groups, item)
      })
    },
  },
}
</script>
